import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminAffiliateReport from "@/pages/AdminAffiliateReport";
import StaffAdminGate from "@/components/StaffAdminGate";

export const Route = createFileRoute("/admin/reporting")({
  head: () => seoHead("/admin/reporting"),
  component: () => (
    <StaffAdminGate><AdminAffiliateReport /></StaffAdminGate>
  ),
});
